import request from '@/utils/request'

// 查询文章列表列表
export function getArticleLlist(data) {
    return request({
        url: "/client/articles/listByCode",
        method: "POST",
        data: data
    });
}
export function helpFeedbackList(data) {
    return request({
        url: "/client/articles/helpFeedbackList",
        method: "POST",
        data: data
    });
}

export function helpFeedbackCategorizeList() {
    return request({
        url: "/client/articles/helpFeedbackCategorizeList",
        method: "POST",

    });
}
export function detailByCode(data) {
    return request({
        url: "/client/articles/detailByCode",
        method: "POST",
        data: data
    });
}